<template lang="pug">
.addUnit__deviceInfo
  van-nav-bar(
    :title="$t('protocol.title')"
    left-arrow
    @click-left="close"
    @click-right="saveProtocol")
    van-icon(name="save" slot="right")

  .main.addUnit__protocol
    //- Activar/Desactivar programación
    .addUnit__protocolSwitch(v-if="hasBacnet")
      span.addUnit__protocolSwitch__title(:class="{select:!bacneton}") {{ $t("protocol.modbus") }}
      van-switch(v-model="bacneton")
      span.addUnit__protocolSwitch__title(:class="{select:bacneton}") {{ $t("protocol.bacnet") }}

    //- Modbus
    div(v-if="!bacneton")
      .van-cell-group__title
        | {{ $t("protocol.modbus") }}

      van-cell-group.addUnit__popup__cell-group
        van-field(
          type="number"
          v-if="device.modbusaddr !== undefined"
          v-model="modbusaddr"
          :label="$t('protocol.modbusaddr')"
          :error-message="modbusaddrError")
        van-cell.van-cell--value-select(
          v-if="device.modbusspeed !== undefined"
          size="large"
          :title="$t('protocol.modbusspeed')"
          :value="modbusspeed"
          @click="openSetSpeed(modbusspeed, 'modbus')")

    //- Bacnet
    div(v-if="bacneton")
      .van-cell-group__title
        | {{ $t("protocol.bacnet") }}

      van-cell-group.addUnit__popup__cell-group
        van-field(
          type="number"
          v-if="device.bacnetmac !== undefined"
          v-model="bacnetmac"
          :label="$t('protocol.bacnetmac')"
          :error-message="bacnetmacError")
        van-field(
          type="number"
          v-if="device.bacnetid !== undefined"
          v-model="bacnetid"
          :label="$t('protocol.bacnetid')"
          :error-message="bacnetidError")
        van-cell.van-cell--value-select(
          v-if="device.bacnetspeed !== undefined"
          :title="$t('protocol.bacnetspeed')"
          :value="bacnetspeed"
          @click="openSetSpeed(bacnetspeed, 'bacnet')")
        van-field(
          type="number"
          v-if="device.bacnetmaxnum !== undefined"
          v-model="bacnetmaxnum"
          :label="$t('protocol.bacnetmaxnum')"
          :error-message="bacnetmaxnumError")
        van-field(
          type="number"
          v-if="device.bacnetmaxframes !== undefined"
          v-model="bacnetmaxframes"
          :label="$t('protocol.bacnetmaxframes')"
          :error-message="bacnetmaxframesError")

</template>

<script>
import BluetoothService from '@/services/bluetooth.service';
import { getErrorId } from '@/services/error.service';
import { parseBoolean } from '@/utils/sanitaze.utils';

export default {
  data() {
    return {
      modbusaddr: this.device.modbusaddr || null,
      modbusspeed: this.device.modbusspeed || null,
      bacneton: null,
      bacnetmac: this.device.bacnetmac || null,
      bacnetid: this.device.bacnetid || null,
      bacnetmaxnum: this.device.bacnetmaxnum || null,
      bacnetspeed: this.device.bacnetspeed || null,
      bacnetmaxframes: this.device.bacnetmaxframes || null,
      speeds: [300, 600, 1200, 2400, 4800, 9600, 19200, 38400, 57600, 76800, 115200],
      isLoading: false,
      modbusaddrError: null,
      bacnetmacError: null,
      bacnetidError: null,
      bacnetmaxnumError: null,
      bacnetmaxframesError: null,
    };
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasBacnet() {
      return this.device.bacneton !== undefined;
    },

    arraySpeeds() {
      return this.speeds.map(item => {
        return { description: `${item}` };
      });
    },
  },
  methods: {
    /**
     * Muestra el selector de temperatura
     */
    openSetSpeed(value, protocol) {
      const configSpeed = {
        title: this.$i18n.t('protocol.selectSpeed'),
        items: [[this.arraySpeeds]],
        positiveButtonText: this.$i18n.t('protocol.done'),
        negativeButtonText: this.$i18n.t('protocol.cancel'),
        theme: 'dark',
        defaultItems: {
          0: `${value}`,
        },
      };

      window.SelectorCordovaPlugin.showSelector(configSpeed, result => {
        if (protocol === 'modbus') {
          this.modbusspeed = parseInt(result[0].description, 10);
        } else {
          this.bacnetspeed = parseInt(result[0].description, 10);
        }
      });
    },

    /**
     * Guarda los datos
     */
    // eslint-disable-next-line
    async saveProtocol() {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Inicializo valores
        this.modbusaddrError = null;
        this.bacnetmacError = null;
        this.bacnetidError = null;
        this.bacnetmaxnumError = null;
        this.bacnetmaxframesError = null;

        // Valido los datos
        if (
          this.device.modbusaddr !== undefined &&
          (!this.modbusaddr || this.modbusaddr < 1 || this.modbusaddr > 128)
        ) {
          this.modbusaddrError = this.$i18n.t('protocol.modbusaddrError');
          return;
        }
        if (
          this.device.bacnetmac !== undefined &&
          (!this.bacnetmac || this.bacnetmac < 1 || this.bacnetmac > 127)
        ) {
          this.bacnetmacError = this.$i18n.t('protocol.bacnetmacError');
          return;
        }
        if (
          this.device.bacnetid !== undefined &&
          (!this.bacnetid || this.bacnetid < 1 || this.bacnetid > 4194303)
        ) {
          this.bacnetidError = this.$i18n.t('protocol.bacnetidError');
          return;
        }
        if (
          this.device.bacnetmaxnum !== undefined &&
          (!this.bacnetmaxnum || this.bacnetmaxnum < 1 || this.bacnetmaxnum > 127)
        ) {
          this.bacnetmaxnumError = this.$i18n.t('protocol.bacnetmaxnumError');
          return;
        }
        if (
          this.device.bacnetmaxframes !== undefined &&
          (!this.bacnetmaxframes || this.bacnetmaxframes < 1 || this.bacnetmaxframes > 127)
        ) {
          this.bacnetmaxframesError = this.$i18n.t('protocol.bacnetmaxframesError');
          return;
        }

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: this.$i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;

        // Preparo los datos
        const data = {};

        if (this.bacneton !== null) data.bacneton = this.bacneton ? 1 : 0;
        if (this.bacnetmac !== null) data.bacnetmac = parseInt(this.bacnetmac, 10);
        if (this.bacnetid !== null) data.bacnetid = parseInt(this.bacnetid, 10);
        if (this.bacnetmaxnum !== null) data.bacnetmaxnum = parseInt(this.bacnetmaxnum, 10);
        if (this.bacnetspeed !== null) data.bacnetspeed = parseInt(this.bacnetspeed, 10);
        if (this.bacnetmaxframes !== null)
          data.bacnetmaxframes = parseInt(this.bacnetmaxframes, 10);
        if (this.modbusaddr !== null) data.modbusaddr = parseInt(this.modbusaddr, 10);
        if (this.modbusspeed !== null) data.modbusspeed = parseInt(this.modbusspeed, 10);

        // Realizo la petición
        await BluetoothService.setExtrainfo(this.device.id, JSON.stringify(data));
        const result = await BluetoothService.getDeviceInfo(this.device.id);

        if (result.bacneton !== undefined) result.bacneton = parseBoolean(result.bacneton);

        this.$toast.clear();
        this.$toast.success({
          mask: true,
          message: this.$i18n.t('protocol.success'),
        });
        this.close(result.extrainfo);
      } catch (error) {
        // Obtengo el error
        getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: this.$i18n.t('protocol.error') });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Cierra este componente
     */
    close(data) {
      this.$emit('close', data);
    },
  },

  created() {
    this.bacneton = this.device.bacneton !== undefined ? this.device.bacneton : null;
  },
};
</script>
